import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useLanguage } from "../i18n/LanguageContext";

/* Standalone "From the Sunnah" badge — same data source as Today's Plan
   (GET /plan/today), but rendered as its own card on the front page instead
   of embedded inside the plan. */
export default function HadithOfDayBadge() {
  const { tx, t } = useLanguage();
  const [hadith, setHadith] = useState(undefined);

  useEffect(() => {
    api.get("/plan/today").then((r) => setHadith(r.data?.hadith || null)).catch(() => setHadith(null));
  }, []);

  if (!hadith) return null;

  return (
    <div className="hifz-card grain bg-forest-700 border-forest-700 text-sand-100" data-testid="hadith-of-day-badge">
      <div className="text-[10px] uppercase tracking-[0.22em] text-gold-500 font-semibold">{t("hadithOfDayBadge.fromTheSunnahForYou")}</div>
      <p className="mt-2 font-display leading-relaxed">"{tx(hadith.text)}"</p>
      <div className="mt-1.5 text-xs text-sand-100/70">{hadith.source}</div>
      <p className="mt-2 text-sm text-gold-500/90" data-testid="hadith-note">{hadith.note}</p>
    </div>
  );
}
